<div class="columns">
  <div class="column custom-box has-background-white p-3">
    <div class="columns">
      <div class="column is-12 ">
        <app-ticket-histories
          [passengers]="(passengers$ | async)"
          [enabledCheckboxes]="false"
        >
        </app-ticket-histories>
      </div>
    </div>
  </div>
</div>